import { PaymentMethodBalanceDTO } from 'core/api';
import { z } from 'zod';
import { DenominationCount, denominationSchema, denominationValues } from './Denomination';
import { Currency, Math } from 'core/utils';
import { zMonetary } from 'core/infrastructure-next';

export const balanceSchema = z.object({
	denominations: z.array(denominationSchema),
	other: zMonetary({ nonNegative: true }).nullable()
});

export type Balance = z.infer<typeof balanceSchema>;

export function hasIncident(balances: PaymentMethodBalanceDTO[]): boolean {
	return balances.some(x => x.ActualEndAmount !== x.ExpectedEndAmount);
}

export function zero(): Balance {
	return {
		denominations: denominationValues.map((val) => ({
			value: val,
			count: 0,
		})),
		other: 0
	};
}

export function create(count: DenominationCount): Balance {
	return {
		denominations: count.coins.concat(count.bills).map(denomination => ({ ...denomination })),
		other: count.other
	};
}

export function createCount(balance: Balance): DenominationCount {
	return {
		coins: balance.denominations.filter(x => x.value < 5).map(denomination => ({ ...denomination })),
		bills: balance.denominations.filter(x => x.value >= 5).map(denomination => ({ ...denomination })),
		other: balance.other
	};
}

export function total(balance: Balance): number {
	const cents = balance.denominations.sum(x => (x.count ?? 0) * x.value);
	return Math.round((balance.other ?? 0) + cents, Currency.DECIMAL_PLACES);
}

export function matchAllExpected(balances: PaymentMethodBalanceDTO[]): PaymentMethodBalanceDTO[] {
	return balances.map(x => ({
		...x,
		ActualEndAmount: x.ExpectedEndAmount
	}));
}